<template>
  <IndicatorCard
    :loading="loading"
    :has-data="downtimes.length > 0"
    :is-result="isResult"
    :no-data-message="$t('Nenhum tempo de máquina parada encontrado')"
    :title="title"
    :description="indicator.description"
    :excel-endpoint="indicator.excelEndpoint"
    :hide-excel="!isResult"
    :excel-loading="excelLoading"
    @export-excel="requestExcel"
  >
    <v-row class="ma-0" dense v-if="!isResult">
      <v-col cols="12">
        <v-autocomplete
          multiple
          v-model="filter.standardEquipment"
          @change="list"
          :items="standardEquipments"
          :disabled="isResult"
          item-text="name"
          return-object
          append-icon="mdi-chevron-down"
          :label="$t('Equipamentos padrão')"
          placeholder="Todas"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <template #date-range>
      <DateRangePicker
        :start-date="startDate"
        :end-date="endDate"
        :disabled="isResult"
        @change="onDateRangeChange"
      />
    </template>

      <v-row class="ma-0" justify="center">
        <v-col cols="12">
          <strong>Total: {{ total }}</strong>

          <div>
            <div class="hidden-md-and-up">
              <v-data-table
                :loading="loading"
                :loading-text="$t('Carregando...')"
                :no-data-text="$t('Nenhum registro encontrado')"
                :headers="downtimeMobileHeader"
                :items="downtimes"
                class="main-table"
                hide-default-footer
                show-expand
                item-key="serviceOrderNumber"
                :single-expand="false"
                :items-per-page="7"
                :header-props="headerProps"
                :mobile-breakpoint="330"
                :expanded.sync="expanded"
                @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
              >
                <template v-slot:[`item.standardEquipment`]="{ item }">
                  {{ item.standardEquipmentName }}
                </template>

                <template v-slot:[`item.totalDowntime`]="{ item }">
                  {{ item.totalDowntime }}
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Identificação') }}:</strong>
                        {{ item.equipmentIdentification }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Fabricante') }}:</strong>
                        {{ item.manufacturer }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Modelo') }}:</strong>
                        {{ item.model }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Nº O.S.') }}:</strong>
                        {{ item.serviceOrderNumber }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Data Parada') }}:</strong>
                        {{ item.stopDate }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Data Retorno') }}:</strong>
                        {{ item.returnDate }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Disponibilidade') }}:</strong>
                        {{ item.availability }}
                      </p>
                    </v-col>
                  </td>
                </template>
              </v-data-table>
              <div class="pagination">
                <div class="item-pagination block-two">
                  <v-pagination
                    class="pagination-item"
                    v-model="page"
                    :length="totalPages"
                    :total-visible="9"
                  ></v-pagination>
                </div>
              </div>
            </div>

            <div class="hidden-md-and-down">
              <v-data-table
                :loading="loading"
                :headers="downtimeHeader"
                :items="downtimes"
                class="main-table"
                :hide-default-footer="!filterProp.data"
                hide-default-header
                item-key="serviceOrderNumber"
                :header-props="headerProps"
                :items-per-page="7"
                :mobile-breakpoint="0"
              >
                <template #header="{ props, on }">
                  <thead>
                    <tr>
                      <th
                        class="text-center"
                        v-for="header in props.headers"
                        :key="header.value"
                      >
                        <v-simple-checkbox
                          v-if="header.value === 'data-table-select'"
                          v-model="props.everyItem"
                          :indeterminate="props.someItems && !props.everyItem"
                          color="purple"
                          @input="on['toggle-select-all']"
                        ></v-simple-checkbox>

                        <div>
                          <v-hover v-slot="{ hover }">
                            <div>
                              <span>{{ $t(header.text) }}</span>
                              <v-icon
                                v-if="
                                  hover &&
                                  header.value != 'data-table-select' &&
                                  header.value != 'actions'
                                "
                                color="white"
                                class="mx-2"
                                @click="on.sort(header.value)"
                              >
                                {{
                                  props.options.sortBy.includes(header.value)
                                    ? `mdi-chevron-down`
                                    : `mdi-chevron-up`
                                }}
                              </v-icon>
                            </div>
                          </v-hover>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>

                <template v-slot:[`item.standardEquipment`]="{ item }">
                  {{ item.standardEquipmentName }}
                </template>

                <template v-slot:[`item.identification`]="{ item }">
                  {{ item.equipmentIdentification }}
                </template>

                <template v-slot:[`item.manufacturer`]="{ item }">
                  {{ item.manufacturer }}
                </template>

                <template v-slot:[`item.model`]="{ item }">
                  {{ item.model }}
                </template>

                <template v-slot:[`item.stopDate`]="{ item }">
                  {{ item.stopDate }}
                </template>

                <template v-slot:[`item.returnDate`]="{ item }">
                  {{ item.returnDate }}
                </template>

                <template v-slot:[`item.totalDowntime`]="{ item }">
                  {{ item.totalDowntime ? item.totalDowntime : '00:00:00' }}
                </template>

                <template v-slot:[`item.duringWorkDowntime`]="{ item }">
                  {{
                    item.duringWorkDowntime
                      ? item.duringWorkDowntime
                      : '00:00:00'
                  }}
                </template>

                <template v-slot:[`item.availability`]="{ item }">
                  {{ item.availability }}
                </template>
              </v-data-table>
              <div class="pagination" v-if="!filterProp.data">
                <div class="item-pagination block-two">
                  <v-pagination
                    class="pagination-item"
                    v-model="page"
                    :length="totalPages"
                    :total-visible="9"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

    <template #review>
    

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult && review">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else-if="!isResult">
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
    </template>
  </IndicatorCard>
</template>

<script>
import { getIndicatorById } from '../../../../../indicators/indicatorRegistry'
import ApiService from '../../../../../../../../services/ApiService'
import Utils from '../../../../../../../../Utils/FormatDate'
import moment from 'moment'
import IndicatorCard from '../../shared/IndicatorCard.vue'
import DateRangePicker from '../../shared/DateRangePicker.vue'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  props: {
    title: { type: String, default: '' },
    apiEndpointOverride: { type: String, default: '' },
    snapshotData: { type: Object, default: null },
    filterProp: Object,
    institution: Object,
    unidades: Array,
    standardEquipments: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  components: {
    IndicatorCard,
    DateRangePicker,
    TiptapVuetify,
  },

  data() {
    return {
      excelLoading: false,
      startDate: '',
      endDate: '',
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {
        page: 1,
        pageSize: 7,
        institutionId: null,
        unidadeIds: [],
        standardEquipment: [],
        startDate: null,
        endDate: null,
        review: '',
      },
      apiService: new ApiService(),
      loading: true,
      downtimes: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      downtimeHeader: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Equipamento Padrão',
          align: 'center',
          value: 'standardEquipment',
          sortable: false,
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'identification',
          sortable: false,
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'manufacturer',
          sortable: false,
        },
        {
          text: 'Num. OS',
          align: 'center',
          value: 'serviceOrderNumber',
          sortable: false,
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'model',
          sortable: false,
        },
        {
          text: 'Data de Parada',
          align: 'center',
          value: 'stopDate',
          sortable: false,
        },
        {
          text: 'Data de Retorno',
          align: 'center',
          value: 'returnDate',
          sortable: false,
        },
        {
          text: 'Tempo Parado (hora)',
          align: 'center',
          value: 'totalDowntime',
          sortable: false,
        },
        {
          text: 'Tempo Parado (Expediente)',
          align: 'center',
          value: 'duringWorkDowntime',
          sortable: false,
        },
        {
          text: 'Disponibilidade',
          align: 'center',
          value: 'availability',
          sortable: false,
        },
      ],
      downtimeMobileHeader: [
        {
          text: '',
        },
        {
          text: 'Equipamento Padrão',
          align: 'center',
          value: 'standardEquipment',
        },
        {
          text: 'Tempo Parado (hora)',
          align: 'center',
          value: 'totalDowntime',
        },
      ],
      total: 0,
    }
  },

  async created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },
  computed: {
    indicator() {
      return getIndicatorById('stopped_machine') || {}
    },
  },


  methods: {
    onDateRangeChange({ startDate, endDate }) {
      this.startDate = startDate
      this.endDate = endDate
      this.filter.page = 1
      this.page = 1
      this.filterProp.data = null
      this.list()
    },

    requestExcel() {
      if (!this.indicator.excelEndpoint) return
      this.excelLoading = true
      const filename = `${this.indicator.legacyKey}.xlsx`
      this.apiService
        .post(this.indicator.excelEndpoint, { ...this.filter, pageSize: 999999 })
        .then((response) => {
          const data = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = data
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => {
          this.excelLoading = false
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },
    setInfos() {
      const model = {
        chart: getIndicatorById('stopped_machine').legacyKey,
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    async list() {
      this.loading = true
      try {
        if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.downtimes = response.content.objects
        this.totalPages = response.content.pager.totalPages
        this.total = response.content.pager.totalItems
        return
        }

        if (!this.isResult) this.setDates()
        this.filter.institutionId = this.institution.id
        this.filter.pageSize = 7
        this.filter.unidadeIds = this.unidades
        const response = await this.apiService.post(
        this.apiEndpointOverride || 'reports/machineDowntime', this.filter
        )
        this.downtimes = response.content.objects
        this.totalPages = response.content.pager.totalPages
        this.total = response.content.pager.totalItems
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      return Utils.dateTime(date)
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
